module.exports = __webpack_public_path__ + "assets/11cf497da426848772d97ee98d54c52252.jpg";